var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphWidget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C17.794 0 16 1.794 16 4C16 4.067 16.017 4.13 16.02 4.196L7.386 6.894C6.679 5.761 5.431 5 4 5C1.794 5 0 6.794 0 9C0 11.206 1.794 13 4 13C4.802 13 5.547 12.757 6.174 12.349L12.484 18.133C12.185 18.693 12 19.322 12 20C12 22.206 13.794 24 16 24C18.206 24 20 22.206 20 20C20 18.487 19.146 17.184 17.904 16.504L20.031 7.997C22.222 7.98 24 6.195 24 4C24 1.805 22.206 0 20 0ZM4 11C2.895 11 2 10.105 2 9C2 7.895 2.895 7 4 7C5.105 7 6 7.895 6 9C6 10.105 5.105 11 4 11ZM18 20C18 21.105 17.105 22 16 22C14.895 22 14 21.105 14 20C14 18.895 14.895 18 16 18C17.105 18 18 18.895 18 20ZM15.969 16.003C15.179 16.009 14.445 16.248 13.826 16.65L7.516 10.866C7.815 10.306 8 9.677 8 8.999C8 8.932 7.983 8.869 7.98 8.803L16.614 6.105C16.979 6.689 17.49 7.163 18.096 7.495L15.97 16.003H15.969ZM20 6C18.895 6 18 5.105 18 4C18 2.895 18.895 2 20 2C21.105 2 22 2.895 22 4C22 5.105 21.105 6 20 6Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphWidget);
export default __webpack_public_path__ + "static/media/graph-widget.d559e90a7c0d91c8c11fd389364dc20b.svg";
export { ForwardRef as ReactComponent };